import React from 'react'
import ServiceCard from './ServiceCard'
import { Col } from 'reactstrap'

import weatherImg from '../../assets/images/weather.png'
import guideImg from '../../assets/images/guide.png'
import customizationImg from '../../assets/images/customization.png'

const serviceData = [
    {
        imgUrl:weatherImg,
        title: 'Best Prices',
        desc: 'We Ensure that You Get Best Deals for your Holidays.'
    },
    {
        imgUrl:guideImg,
        title: 'Best Tour Guide',
        desc: 'Our Tour Guide Will Provide you the best Experience within your Tour'
    },
    {
        imgUrl:customizationImg,
        title: 'Customization',
        desc: 'You Can Customize Your Holiday As Per Your Needs'
    },
]

const ServiceList = () => {
  return (
    <>
    {
        serviceData.map((item, index) => (
            <Col lg='3' key={index}>
                <ServiceCard item={item} />
            </Col>
        ))
    }
    
    </>
  )
}

export default ServiceList